import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { useAmbassadorService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';
export var useAmbassadorData = function useAmbassadorData() {
  var _useState = useState(),
      ambassadorData = _useState[0],
      setAmbassadorData = _useState[1];

  var ambassadorService = useAmbassadorService();

  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated,
      user = _useAuth.user;

  useEffect(function () {
    var callApi = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var meResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((user === null || user === void 0 ? void 0 : user.type) !== 'ambassador')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return ambassadorService.me();

              case 5:
                meResponse = _context.sent;
                setAmbassadorData(meResponse.data);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0, 'error fetching ambassador data');

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      return function callApi() {
        return _ref.apply(this, arguments);
      };
    }();

    if (isAuthenticated) callApi();
  }, [ambassadorService, isAuthenticated, user === null || user === void 0 ? void 0 : user.type]);
  return ambassadorData;
};